enum KeystoreDialogFields {
	TYPE = "type",
	FILE = "file",
	PASSWORD = "password"
}

export default KeystoreDialogFields;